module.exports = __webpack_public_path__ + "static/unwomen-twitter-new-e48760e1ca135dd1e436a68f30a6b981.png";